import React from 'react'
import Map, { Layer, NavigationControl, Source, ViewState } from 'react-map-gl/maplibre'
import 'maplibre-gl/dist/maplibre-gl.css'
import { PolygonData } from './EcommerceSettingModels'
import { GeoJSONHelpers, rgbaToHex } from '../../../../utilities/helpers'
import config from '../../../../config'

interface Props {
  data: Omit<PolygonData, 'name'>
}

export const AWSLocationMap = ({
  data: { fillColor, lineColor, coordinates },
}: React.PropsWithChildren<Props>) => {
  const helper = GeoJSONHelpers(coordinates)

  const defaultZoom = 12
  const defaultViewState: Partial<ViewState> = {
    longitude: helper.getCenter()[0],
    latitude: helper.getCenter()[1],
  }

  const [viewState, setViewState] = React.useState<Partial<ViewState>>(defaultViewState)
  const [zoom, setZoom] = React.useState<number>(defaultZoom)

  const maxBounds = helper.getMaxBounds()

  return (
    <Map
      {...viewState}
      zoom={zoom}
      maxBounds={maxBounds}
      style={{ height: '20vh', width: '20vw' }}
      mapStyle={`https://maps.geo.${config.aws.location.region}.amazonaws.com/maps/v0/maps/${config.aws.location.mapName}/style-descriptor?key=${config.aws.location.apiKey}`}
      attributionControl={false}
      onLoad={() => setZoom(defaultZoom)}
      onMove={(evt) => setViewState(evt.viewState)}
      onZoom={(evt) => setZoom(evt.viewState.zoom)}
    >
      <NavigationControl position='bottom-right' showZoom showCompass={false} />

      <Source type='geojson' data={helper.toGeoJSON()}>
        <Layer type='fill' paint={{ 'fill-color': rgbaToHex(fillColor) }} />
        <Layer type='line' paint={{ 'line-color': rgbaToHex(lineColor), 'line-width': 1 }} />
      </Source>
    </Map>
  )
}
